/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ApplicationInputs */

const en_nav_application = /** @type {(inputs: Nav_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application`)
};

const pt_br2_nav_application = /** @type {(inputs: Nav_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicativo`)
};

/**
* | output |
* | --- |
* | "Application" |
*
* @param {Nav_ApplicationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_application = /** @type {((inputs?: Nav_ApplicationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ApplicationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_application(inputs)
	return pt_br2_nav_application(inputs)
});